import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';
import {UmpireComponent} from '../umpire-component';
import {UmpireRound} from '../umpire-round';
import {UmpireCompetition} from '../umpire-competition';

export interface UmpireComponentRound
  extends UmpireComponent<UmpireComponentTypeEnum.ROUND> {
  round: UmpireRound | null;
  competition: UmpireCompetition | null;
  show_current: boolean;
}
